import { render, staticRenderFns } from "./CustomTagLabels.vue?vue&type=template&id=26ec62aa&scoped=true"
import script from "./CustomTagLabels.vue?vue&type=script&lang=js"
export * from "./CustomTagLabels.vue?vue&type=script&lang=js"
import style0 from "./CustomTagLabels.vue?vue&type=style&index=0&id=26ec62aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ec62aa",
  null
  
)

export default component.exports
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinner,QIcon});
